export default "__VITE_ASSET__C2SWqNT3__"